'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Summary = require('./Summary');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Summary).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Summary/index.js
// module id = 1302
// module chunks = 1